const baseurl = {
  // http: 'http://10.168.30.98/api/'
  http: 'https://api.shmwh.com/api/'
  //
}
export default baseurl



// WEBPACK FOOTER //
// ./src/util/baseUrl.js